import { SDLUtil, RequestUtil } from '@/utils';

const setRemRole = ({ commit }, remRole) => {
  commit('SET_REM_ROLE', remRole);
};
const setUserPrmsYn = ({ commit }, userPrmsYn) => {
  commit('SET_USER_PRMS_YN', userPrmsYn);
};

const setInfraManagerYn = ({ commit }, infraManagerYn) => {
  commit('SET_INFRA_MANAGER_YN', infraManagerYn);
};

const setRdsManagerYn = ({ commit }, rdsManagerYn) => {
  commit('SET_RDS_MANAGER_YN', rdsManagerYn);
}

const setDivisionCd = ({ commit }, divisionCd) => {
  commit('SET_DIVISION_CD', divisionCd);
};

export default {
  async GET_REM_USER(store) {
    const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/common/GetRemUser`);
    const { remRole, userPrmsYn, infraManagerYn, rdsManagerYn, divisionCd } = response.data.data;
    setRemRole(store, remRole);
    setUserPrmsYn(store, userPrmsYn);
    setInfraManagerYn(store, infraManagerYn);
    setRdsManagerYn(store, rdsManagerYn);
    setDivisionCd(store, divisionCd);
    return response;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/rem/user/remUserAction.js